import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  updateCommitedDeliveryDate,
  updateStatus,
} from "features/stock-ordering/core/stock-ordering.params";
import {
  updateCommitedDeliveryResponse,
  updateCommitedDeliveryRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum updateCommitedDeliveryState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: updateCommitedDeliveryState;
  message: string;
}

const initialState: InitialState = {
  status: updateCommitedDeliveryState.initial,
  message: "",
};

export const updateCommitedDelivery = createAsyncThunk(
  "updateCommitedDelivery",
  async (param: updateCommitedDeliveryDate, { rejectWithValue }) => {
    try {
      const response: updateCommitedDeliveryResponse =
        await updateCommitedDeliveryRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const updateCommitedDeliverySlice = createSlice({
  name: "updateCommitedDelivery",
  initialState,
  reducers: {
    resetupdateCommitedDelivery: (state) => {
      state.status = updateCommitedDeliveryState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCommitedDelivery.pending, (state) => {
        state.status = updateCommitedDeliveryState.inProgress;
      })
      .addCase(updateCommitedDelivery.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = updateCommitedDeliveryState.success;
          state.message = message;
        }
      })
      .addCase(updateCommitedDelivery.rejected, (state, action) => {
        state.status = updateCommitedDeliveryState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectUpdateCommitedDelivery = (state: RootState) =>
  state.updateCommitedDelivery;

export const { resetupdateCommitedDelivery } =
  updateCommitedDeliverySlice.actions;
export default updateCommitedDeliverySlice.reducer;
